import type { AppConfigType } from 'config/types';
import React from 'react';

export const AppConfigContext = React.createContext<AppConfigType>({} as AppConfigType);
